import React, { useRef,useEffect,useState } from 'react'
 import { useStore } from './store'
import AppConfig from '../Home/Config.js';
import { useSpring, animated,useTrail } from 'react-spring';
import { Light } from 'three';
import { Howl, Howler } from 'howler';
import ReactHowler from 'react-howler';
import {useNavigate ,useLocation ,useSearchParams } from 'react-router-dom';
import { useGesture , useDrag} from '@use-gesture/react';
import './style.css';
import { Center } from '@react-three/drei';
const hostloca=AppConfig.cdnUrl;



let cardgroup=[0,3,4,5,8,10,11,15,20,22]

let cardmark=[0,0,0,0,1,0,0,0,0,0]

let pickmark=[0,0,0,0,0,0,0,0,0,0]
let targetcard=4
let setcard=false

let tempx=0
let candrag=true
let picked_card=0


let setdata=false


function Cardlist(props){
  const [cardurl,setcardurl]=useState([])
  const [discardurl,setdiscardurl]=useState([])
  const [cardpose,setcardpose]=useState([])

  const [tpickcard,settpickcard]=useState([['',1],['',1],['',1]])

  const [pickbtnalpha,setpickbtnalpha]=useState(1)

  const [layerpickcardalpha,setlayerpickcardalpha]=useState(0)

  const [sendcardlayer,setsendcardlayer]=useState(false)
  const [sendcardlayeralpha,setsendcardlayeralpha]=useState(0)

  const [disablecard,setdisablecard]=useState([0,0,0,0,0,0,0,0,0,0])

  const [collectcardcount,setcollectcardcount]=useState(0)
  

  let w=window.innerWidth
  let h=window.innerHeight

  const storedName = localStorage.getItem('mm_user_nick');
   
    
   useEffect(()=>{

   

      if(setcard==false){
        setcard=true
        cardmark=[0,0,0,0,1,0,0,0,0,0]
        pickmark=[0,0,0,0,0,0,0,0,0,0]
        targetcard=4
        picked_card=0


        //=============================================

       
        const mmusermarktype = localStorage.getItem('mm_user_marktype');
        const mmuserticket = localStorage.getItem('mm_user_ticket');
  
        const mmusertopscore = localStorage.getItem('mm_user_top_score');
        let temdiscard=[]
        if(mmusermarktype){

          const aparts = mmusermarktype.split('&');
          const cardlist = aparts[0].split('');

          console.log('set card:'+cardlist)
          temdiscard=cardlist

          setdisablecard(cardlist)


        }  



        //==================================================


      let carurlarray=[]
      let discardurl=[]
      
      let collectc=0
       for(let i=0;i<cardgroup.length;i++){

        if(temdiscard[i]==1)collectc+=1
         carurlarray[i]=hostloca+'Assets/card'+cardgroup[i]+'.png'
         discardurl[i]=hostloca+'Assets/discard'+cardgroup[i]+'.png'
       }

       setcollectcardcount(collectc)
 
      resetcardpose(targetcard)
 
       setcardurl(carurlarray)
       setdiscardurl(discardurl)

      // console.log(cardurl)

      setlayerpickcardalpha(1)
 
    
 
   
      }


   },[])



   function resetcardpose(targetcard){
           let cardposetem=[]
        for(let i=0;i<cardgroup.length;i++){
           cardmark[i]=0
           cardposetem[i]=[]
           cardposetem[i][1]=10 
           cardposetem[i][3]=0 
           if(i<targetcard){
            cardposetem[i][0]=-w 
            cardposetem[i][2]=.7 
            cardposetem[i][3]=40
             if(targetcard-i==1){
              cardposetem[i][0]=-w*.7+w*.2
             }
           }else if(i>targetcard){
            cardposetem[i][0]=w 
            cardposetem[i][2]=.7 
            cardposetem[i][3]=-40

            if(i-targetcard==1){
              cardposetem[i][0]=w*.85-w*.05
            }
           }else{
            cardposetem[i][0]=w*.15
            cardposetem[i][1]=30 
            cardposetem[i][2]=.8 
            cardposetem[i][3]=0

            if(picked_card<=2){

                if(pickmark[targetcard]==1 || disablecard[targetcard]==0){

                  setpickbtnalpha(.4)
                }else{
                  setpickbtnalpha(1)
                }

              }
        
           
           }

          
         
        }  

        cardmark[targetcard]=1

        setcardpose(cardposetem)
        

   }




  


   const bindqatwodrag = useGesture({
    onDragStart: ({down,movement: [mx] }) => {
    
      if(down){
          
          
        tempx=mx
            
       }
  },

  onDrag: ({ down, movement: [mx] }) => {
      
    if (!down) {

 

    }

    if (down) {
     

       // console.log('drag mov'+(tempx-mx))
       
           if(candrag){
             
              if(tempx-mx>=9){
                    console.log('left')
                    candrag=false
                    if(targetcard+1<cardgroup.length){
                      targetcard+=1
                      resetcardpose(targetcard)
                    }

              }else if(tempx-mx<=-9){
                    console.log('right')
                    candrag=false
                    if(targetcard-1>=0){
                      targetcard-=1
                      resetcardpose(targetcard)
                    }
              }
          }
 
    }

     
  },onDragEnd:({ down, movement: [mx]})=>{
      
       console.log('drag end')

     

       candrag=true
   }
  });

  function resetpick(){
    settpickcard([['',1],['',1],['',1]])
    picked_card=0
    pickmark=[0,0,0,0,0,0,0,0,0,0]
    setpickbtnalpha(1)
}


const handelpicked=(e)=>{

 

    let temppickarray=JSON.parse(JSON.stringify(tpickcard)); 
     
    



      if(picked_card==3){
   
            console.log('send card')
            setpickbtnalpha(.5)
            setlayerpickcardalpha(0)
            setsendcardlayer(true)

            //分享文案
            let posemsg={code:'8888',nickname:storedName}
            window.Wxminiposemessage(posemsg)
            

            setTimeout(() => {
              setsendcardlayeralpha(1)
            }, 700);
       
       }else{

                if(pickmark[targetcard]==0){
                      if( disablecard[targetcard]==1){
                          if(picked_card==0){
                          
                          temppickarray[0][0]=cardgroup[targetcard]
                          temppickarray[0][1]=3
                          picked_card=1
                          pickmark[targetcard]=1
                          settpickcard(temppickarray)
                          setpickbtnalpha(.5)
                          }else if(picked_card==1){
                
                          temppickarray[1][0]=cardgroup[targetcard]
                          temppickarray[1][1]=3
                          picked_card=2
                          pickmark[targetcard]=1
                          settpickcard(temppickarray)
                          setpickbtnalpha(.5)
                          }else if(picked_card==2){
                
                          temppickarray[2][0]=cardgroup[targetcard]
                          temppickarray[2][1]=3
                          picked_card=3
                          pickmark[targetcard]=1
                          settpickcard(temppickarray)
                          setpickbtnalpha(1)
                          } 
                      }
      
        
              }else{
                    
        
                console.log('alread pick')
              }

       }
   

         
  }


  function backtohome(){
    window.location.replace('/')

  }
  




    return <div style={{position:'absolute',top:'0vh',display:'flex',justifyContent:'center',alignItems:'center',left:0,width:'100vw'}}>

                <div style={{position:'absolute',top:'0vh',display:'flex',justifyContent:'center',alignItems:'center',left:0,width:'100vw',opacity:layerpickcardalpha,transition:'all 1s'}} >

                        <div style={{width:'36vw',height:'12vw',position:'absolute',top:'11vh',display:'flex',alignItems:'center',justifyContent:'center'}}>

                                     <div style={{width:'12vw',height:'12vw',display:'flex',alignItems:'center',justifyContent:'center'}}>
                                                      <div className='textscore' style={{textAlign:'center',border:  tpickcard[0][1]+'px solid #ffffff',borderRadius:'50%',width:'60%',height:'60%',color:'white',lineHeight:'4vh',transition:`all .6s`}}>

                                                                    { tpickcard[0][0]}
                                                      </div>

                                     </div>
                                     <div style={{width:'12vw',height:'12vw',display:'flex',alignItems:'center',justifyContent:'center'}}>
                                                     <div className='textscore' style={{textAlign:'center',border:  tpickcard[1][1]+'px solid #ffffff',borderRadius:'50%',width:'60%',height:'60%',color:'white',lineHeight:'4vh',transition:`all .6s`}}>

                                                                    { tpickcard[1][0]}
                                                       </div>

                                     </div>
                                     <div style={{width:'12vw',height:'12vw',display:'flex',alignItems:'center',justifyContent:'center'}}>
                                                               <div className='textscore' style={{textAlign:'center',border:  tpickcard[2][1]+'px solid #ffffff',borderRadius:'50%',width:'60%',height:'60%',color:'white',lineHeight:'4vh',transition:`all .6s`}}>

                                                                   { tpickcard[2][0]}
                                                          </div>

                                     </div>

                        </div>



             {/*-------------------------------*/}

         {/* rotateY('+cardpose[index][3]+'deg)  低版本不支持三维旋转 */}

             <div  tabIndex={-1} {...bindqatwodrag()}    style={{position:'absolute',width:'100vw',height:'100vh',left:0,top:'18vh'}} >

              {cardurl.map((item, index) => ( 


                                        
                                  <div key={index}   style={{width:'70vw',height:'70vh',position:'absolute',top:'0vh',left:cardpose[index][0],zIndex:cardpose[index][1],transition:`all 1s`,transform:'scale('+cardpose[index][2]+')'}}>


                                             <div style={{position:'absolute',width:'100%',opacity:disablecard[index]}}>
                                                <div style={{position:'absolute',width:'100%'}}>
                                                <img  src={hostloca+'Assets/mycardbg.png'} style={{width:'100%'}}/> 
                                                </div>

                                                <div style={{width:'100%',height:'12vw',position:'absolute',top:'4vh',display:'flex',justifyContent:'center',alignItems:'center'}}>
                                                <div style={{position:'absolute',width:'100%',top:'0vh'}}>
                                                <img  src={cardurl[index]} style={{width:'100%'}}/> 

                                                </div>
                                                </div>
                                            </div>


                                            <div style={{position:'absolute',width:'100%',opacity:1-disablecard[index]}}>
                                             <img  src={discardurl[index]} style={{width:'100%'}}/> 
                                             </div>


                                   

                                </div>

                ))}

           </div>


             {/*-------------------------------*/}



             <div style={{width:'100vw',height:'8vw',position:'absolute',top:'4vh',textAlign:'right',float:'right',alignItems:'right',display:'flex',justifyContent:'right'}}>
              
             <div style={{width:'auto',height:"8vw" ,position: 'absolute',right:'14vw'}}>
             <span className='textnormal' style={{fontSize:'3.5vw',letterSpacing:'.3vw',top:'0vh',fontWeight:600,left:'30vw',color:'white',width:'auto',textAlign:'right'}}>{storedName}收集了</span>  
             </div>
              <div style={{width:'13vw',height:"8vw",backgroundImage:'url('+hostloca+'Assets/linec.png)',backgroundSize:'5vw 5vw',backgroundRepeat:'no-repeat',marginLeft:'1vw',textAlign:'left' ,position: 'absolute',right:'0vw'}}>

              <span className='textcard' style={{fontSize:'3vw',letterSpacing:'.3vw',top:'0vh',fontWeight:500,left:'-1vw',color:'white', position: 'relative',top:'-1vw',textAlign:'center',width:'5vw',display:'flex',alignItems:'center',justifyContent:'center'}}>{collectcardcount}</span>  

              <span className='textcard' style={{fontSize:'3vw',letterSpacing:'.3vw',top:'0vh',fontWeight:500,left:'2vw',color:'white', position: 'relative',top:'-.5vw',textAlign:'center',width:'5vw',display:'flex',alignItems:'center',justifyContent:'center'}}>10</span>  

              </div>
                    

              </div>


           <div style={{width:'64vw',height:'20vw',position:'absolute',top:'76vh',display:'flex',alignItems:'center',justifyContent:'center'}}>

             <div  onClick={()=>resetpick()} style={{width:'28vw',height:'8vw',borderRadius:'8vw',color:'white',position:'absolute',left:'0%',top:'0vh',display:'flex',justifyContent:'center',alignItems:'center',fontSize:'3vw',letterSpacing:'.4vw', border: '1.5px solid',zIndex:420,transition:`all .2s`,opacity:1}}>
            
             <img  src={hostloca+'Assets/resetbtn.png'} style={{width:'6vw',position:'absolute',top:'.6vh'}}/>

             </div>
             <div  onClick={handelpicked}   style={{width:'28vw',height:'8vw',borderRadius:'8vw',color:'white',position:'absolute',right:'0%',top:'0vh',display:'flex',justifyContent:'center',alignItems:'center',fontSize:'3vw',letterSpacing:'.4vw', border: '1.5px solid',zIndex:420,transition:`all .2s`,opacity:pickbtnalpha}}>
             <img  src={hostloca+'Assets/pickbtn.png'} style={{width:'4vw',position:'absolute',top:'1.3vh'}}/>
            </div>


            <img  src={hostloca+'Assets/mycardline3.png'} style={{width:'50vw',position:'absolute',top:'10vh'}}/> 


            
            </div>




            </div>



            {/*-----------------------           
--------*/}

            {sendcardlayer? (

            <div style={{width:'100vw',height:'100vh',position:'absolute',display:'flex',justifyContent:'center',alignItems:'center',opacity:sendcardlayeralpha,transition:`all 1s`,top:'0vh',left:0}}>




                              <img  src={hostloca+'Assets/mycardline5.png'} style={{width:'50vw',position:'absolute',top:'10vh'}}/> 
                     


                      <div    style={{width:'70vw',height:'70vh',position:'absolute',top:'12vh',zIndex:3,transition:`all 1s`,display:'flex',justifyContent:'center',alignItems:'center',opacity:sendcardlayeralpha}}>

                          <div style={{position:'absolute',width:'100%'}}>
                          <img  src={hostloca+'Assets/mycardbg.png'} style={{width:'100%'}}/> 
                          </div>

                          <div style={{width:'100%',position:'absolute',top:'14vh',display:'flex',justifyContent:'center',alignItems:'center'}}>
                              <div style={{position:'absolute',width:'100%',top:'0vh'}}>
                              <img  src={hostloca+'Assets/mycardline4.png'} style={{width:'100%'}}/> 

                              </div>
                          </div>


                                        <div style={{width:'36vw',height:'12vw',position:'absolute',top:'30vh',display:'flex',alignItems:'center',justifyContent:'center'}}>

                                                <div style={{width:'12vw',height:'12vw',display:'flex',alignItems:'center',justifyContent:'center'}}>
                                                              <div className='textscore' style={{textAlign:'center',border:  tpickcard[0][1]+'px solid #000',borderRadius:'50%',width:'60%',height:'60%',color:'black',lineHeight:'4vh',transition:`all .6s`}}>

                                                                            { tpickcard[0][0]}
                                                              </div>

                                              </div>
                                              <div style={{width:'12vw',height:'12vw',display:'flex',alignItems:'center',justifyContent:'center'}}>
                                                              <div className='textscore' style={{textAlign:'center',border:  tpickcard[1][1]+'px solid #000',borderRadius:'50%',width:'60%',height:'60%',color:'black',lineHeight:'4vh',transition:`all .6s`}}>

                                                                  { tpickcard[1][0]}
                                                            </div>

                                              </div>
                                              <div style={{width:'12vw',height:'12vw',display:'flex',alignItems:'center',justifyContent:'center'}}>
                                                                <div className='textscore' style={{textAlign:'center',border:  tpickcard[2][1]+'px solid #000',borderRadius:'50%',width:'60%',height:'60%',color:'black',lineHeight:'4vh',transition:`all .6s`}}>

                                                                  { tpickcard[2][0]}
                                                                </div>

                                                  </div>

                                        </div>


                      </div>





                      {/*--------------------------*/}

                      <div  onClick={()=>backtohome()}    style={{width:'28vw',height:'8vw',borderRadius:'8vw',color:'white',position:'absolute',top:'82vh',display:'flex',justifyContent:'center',alignItems:'center',fontSize:'3vw',letterSpacing:'.4vw', border: '1.5px solid',transition:`all .2s`,opacity:1}}>
                         返回首页
                      </div>

            </div>
            ):('')}


           </div>

}






export default function Mycard(props) {

  
  
  let w=window.innerWidth
  let h=window.innerHeight

  const imgradio=2200/1080
  const imgh=window.innerWidth*imgradio
  const bgitemtop=(window.innerHeight-(window.innerWidth*imgradio))/2

  const [videopose,setvideopose]=useState(['100vw','100vh',0,0])
  const videoEl = useRef(null);
  const [videoplaying,setvideoplaying]=useState(false)

  const [cardindex,setcardindex]=useState(true)
  const [cardbg,setcardbg]=useState(0)
  const [cardindexalpha,setcardindexalpha]=useState(0)
  const [creatcard,aetcreatcard]=useState(false)
  const [bgimg,setbgimg]=useState('')
  const [bgvideo,setbgvideo]=useState(true)
  const [bgurl,setbgurl]=useState(hostloca+'media/i1.mp4')

  
  let navigate =useNavigate();
  let location =useLocation()

  const [searchParams] = useSearchParams();
  const gets = searchParams.get('s'); // "param" 是你想获取的查询参数的键



       useEffect(()=>{

        /*

          if(setdata==false){
              setdata=true
            const storedName = localStorage.getItem('mm_user_nick');
            if (storedName) {
                console.log('User : '+storedName)
              //  alert(storedName)
            } 

            const storeopenid = localStorage.getItem('mm_user_opd');
            if (storeopenid) {
                console.log('openid : '+storeopenid)
               // alert(storeopenid)
            } 

        }
        */

       },[]) 

   
      


      useEffect(()=>{


        
      


        let bgimgurl=hostloca+'Assets/4bg2.jpg'

        let bgvideourl=hostloca+'media/i1.mp4'

        if(gets==1){
          bgimgurl=hostloca+'Assets/4bg2.jpg'
          bgvideourl=hostloca+'media/i1.mp4'
        }else if(gets==2){
          bgimgurl= hostloca+'Assets/cbg2.jpg'
          bgvideourl=''
        }else if(gets==3){
          bgimgurl=hostloca+'Assets/cbg3.jpg'
          bgvideourl=hostloca+'media/i3.mp4'

        }

        setbgimg(bgimgurl)
        setbgurl(bgvideourl)
     


       
        let videoradio=664/320
        let h=window.innerHeight
        let videow=window.innerWidth
        let videoh=window.innerWidth*videoradio
        let videotop=0
        let videoleft=0
  
        if(videoh>h){
  
          videotop=(h-videoh)/2
  
        }else{
          videoh=h
          videotop=0
  
          videow=videoh*320/664
  
          videoleft=(window.innerWidth-videow)/2
  
        }
   
          setvideopose([videow,videoh,videoleft,videotop])
   
           
          setTimeout(() => {
            setcardbg(1)
            setcardindexalpha(1)
            setbgvideo(true)
          }, 300);

          


      },[])


        const attemptPlay = () => {
          if (videoEl.current) {
              videoEl.current.play().catch(error => {
                  console.error("Error attempting to play", error);
              });
          }
      };

        // 监听bgurl的变化，当变化时尝试重新加载视频并播放
        useEffect(() => {


 
              const video = videoEl.current;
              if (!video) return;
          
              const handleCanPlay = () => {
                 
                       
                          attemptPlay(); // 尝试播放新视频
                      

              };
          
              video.addEventListener('canplay', handleCanPlay);
          
              // 更新视频源时触发加载
              video.load();
          
              return () => {
                  video.removeEventListener('canplay', handleCanPlay);
              };
        

        }, [bgurl]); // 依赖项列表中添加bgurl


       function backhome(){
        // navigate('/',{state:{id:0,nick:''}})
        

         if(creatcard){

          aetcreatcard(false)
          setcardindexalpha(1)
         // setcardindex(true)

         setcard=false

         }else{
        //  window.location.replace('/')
          navigate('/',{state:{id:0,nick:''}})
         }
       }

       function creatmycard(){
        //==================================================================
  


       //===============================================

        setcardindexalpha(0)
        setTimeout(() => {
          aetcreatcard(true)
        }, 1000);

       }



    return <div>   
                 <div  style={{width:'100vw',height:'100vh',position:'absolute',justifyContent:'center',alignItems:'center',display:'flex',opacity:cardbg,transition:`all 1s`}}>
 
                        <img 
                                src={bgimg} 
                                style={{
                                width:'100%' , // Set image width to screen width
                                position: 'absolute',
                                top: bgitemtop, // Adjust this to position correctly
                                left: 0, // Center the image horizontally
                                }}
                            /> 


                {bgvideo? (

                        <video
                            style={{position:"absolute",display: 'block',width:videopose[0],height:videopose[1],left:videopose[2],top:videopose[3],opacity:1}}
                            playsInline
                            loop
                            muted
                        
                            
                            alt="All the devices"
                            src={bgurl}
                            ref={videoEl}
                        />
                      ):('')}
                      </div>
                   





                 {cardindex? (
                 <div  style={{width:'100vw',height:'100vh',position:'absolute',justifyContent:'center',alignItems:'center',display:'flex',opacity:cardindexalpha,transition:`all 1s`}}>

 
                    <img className='elementabsolute' src={hostloca+'Assets/mycardline9.png'} style={{width:'46vw',top:'14vh'}}/>   

                    {/*
                    <img className='elementabsolute' src={hostloca+'Assets/mycardicon.png'} style={{width:'40vw',top:'26vh'}}/> */}
                    <img className='elementabsolute' src={hostloca+'Assets/cardflip.gif'} style={{width:'85vw',top:'17vh'}}/> 



                    <img className='elementabsolute' src={hostloca+'Assets/mycardline10.png'} style={{width:'52vw',top:'60vh'}}/> 




                     <div onClick={()=>creatmycard()}  className='btnnohightline' style={{position:'absolute',width:'20vw',height:'20vw',top:'76vh',justifyContent:'center',alignItems:'center',display:'flex' }}>
                      
                             <div className="breathing-button"></div>

                             <img className='elementabsolute' src={hostloca+'Assets/mycardgobtn.png'} style={{width:'100%',top:0}}/> 
                         
                       </div>

 


                  </div>

                  

                  ):('')}





                {creatcard? (

                               <div style={{width:'100vw',height:'100vh',position:'absolute',display:'flex',justifyContent:'center',alignItems:'center'}}>

                                   <Cardlist />

                               </div>
                ):('')}

              
            <div onClick={()=>backhome()} className='btnnohightline'  style={{width:'7vw',height:'7vw',position:'absolute',top:'3vh',left:'6vw',opacity:1}}>

            <img  src={hostloca+'Assets/back.png'} style={{width:'100%'}}/> 
                
            </div>


    </div>





}